import axios from "@/api/axiosInstance";
import { GetUserFormDetailsResponse } from "./types";

export const getUserFormDetails = async (
  uuid?: string,
): Promise<GetUserFormDetailsResponse> => {
  const url = uuid
    ? `/api/private/user-form-details/${uuid}`
    : `/api/private/user-form-details`;

  const response = await axios.get<GetUserFormDetailsResponse>(url);
  return response.data;
};
